import $ from 'jquery';
import { scrollToEl } from '../global/helpers';

function handleResults(e) {
	const $locator = $(e.detail.locator.locatorEl);
	if ($locator.length > 0) {
		scrollToEl($locator, 20);
	}

	const message = document.querySelector('.js-emsrl-search-message');
	if (message) {
		message.style.display = 'block';
	}
}

function initZipCodeFields() {
	// Mask zip code fields so that only 5 digits can be entered.
	const $zipCodeInputs = $('.js-emsrl-search, .address_zip > input');
	if ($zipCodeInputs.length > 0) {
		$zipCodeInputs.mask('99999');
	}

	// Update the gravity form's zip code field with the value the user searched for.
	const $repLocatorZip = $('.js-emsrl-search');
	if ($repLocatorZip.length > 0) {
		const $formZip = $('.emsrl-subscriber-zip-code input');
		$repLocatorZip.on('change', () => {
			$formZip.val($repLocatorZip.val());
		});
	}
}

window.addEventListener('emsrlPostFetchPosts', handleResults);
document.addEventListener('DOMContentLoaded', initZipCodeFields);
